<template>
    <base-table-row>
        <base-table-cell>
            <div class="whitespace-nowrap max-w-[4rem] text-center">
                {{ invoice.invoice_number }}
            </div>
            <div class="flex justify-center mt-0.5">
                <span
                    class="text-[10px] px-1.5 rounded uppercase tracking-wide leading-tight"
                    :class="isNativeAerocle ? 'bg-accent-primary text-white' : 'bg-gray-200 text-gray-600'"
                >{{ isNativeAerocle ? 'Aerocle' : 'Wave' }}</span>
            </div>
        </base-table-cell>
        <base-table-cell>
            {{ invoice.status }}
        </base-table-cell>
        <!-- <base-table-cell>
            {{ invoice.wave_status }}
        </base-table-cell> -->
        <base-table-cell>
            <span @click="showAllClientInvoices" class="underline hover:cursor-pointer inline-block min-w-[7rem] max-w-[10rem]">{{ invoice.engagement.client.client_name }}</span>
            <base-modal :is-form-visible="allClientInvoicesVisible" @close="hideAllClientInvoices">
                <template #header>
                    <div>
                        {{ invoice.engagement.client.client_name }} Invoices
                    </div>
                </template>
                <template #body>
                    <div class="max-h-[95vh] overflow-auto">
                        <AllClientInvoices :client-id="invoice.engagement.client.id" />
                    </div>
                </template>
            </base-modal>
        </base-table-cell>
        <!-- <base-table-cell>
            {{ invoice.invoice_number }}
        </base-table-cell> -->
        <base-table-cell>
            <div class=" whitespace-nowrap flex justify-center">
                {{ returnDate(invoice.invoice_date) }}
            </div>
        </base-table-cell>
        <base-table-cell>
        <div class=" whitespace-nowrap flex justify-center">
            {{ returnDate(invoice.due_date) }}
        </div>
    </base-table-cell>
    <base-table-cell>
        <div class=" whitespace-nowrap flex justify-center">
            {{ formatDateTwoDigitYear(invoice.sent_date) }}
        </div>
    </base-table-cell>
    <base-table-cell>
        <div class="whitespace-nowrap flex justify-center" :class="{'bg-[#FFFF01]' : !invoice.date_paid && paymentTiming < 0 && invoice.status === 'Unpaid'}">
            <template v-if="invoice.date_paid">
                {{ returnDate(invoice.date_paid) }}
            </template>
            <template v-else>
                <span :class="{ 'underline cursor-pointer': hasReminders }" @click="hasReminders && showSentInvoiceReminders()">
                    ({{ props.invoice.status === 'Paid' ? 'PD' : 'Due' }}: {{ paymentTiming }})
                </span>
            </template>
        </div>
        <base-modal :is-form-visible="sentInvoiceRemindersVisible" @close="hideSentInvoiceReminders">
            <template #header>
                <div>
                    Invoice #{{ invoice.invoice_number }} Sent Reminders
                </div>
            </template>
            <template #body>
                <div class="max-h-[95vh] overflow-auto">
                    <SentInvoiceReminders :sent-reminders="invoice.sent_reminders" />
                </div>
            </template>
        </base-modal>
    </base-table-cell>
        <!-- <base-table-cell>
            {{ invoice.invoice_service }}
        </base-table-cell> -->
        <base-table-cell>
            <div class="min-w-[20rem]">
                {{ invoice.invoice_for.substr(0, 120) }} <span v-if="invoice.invoice_for.length > 120">...</span>
            </div>
        </base-table-cell>
        <base-table-cell>
            <div class="flex flex-col items-center w-full">
                <div>{{ invoiceAmount }}</div>
                <span v-if="invoice.is_retainer_fee" class="mt-0.5 text-[10px] uppercase tracking-wide bg-gray-200 text-gray-700 rounded px-1.5">retainer</span>
            </div>
        </base-table-cell>
        <base-table-cell>
            <div class="flex flex-col items-center w-full">
                <div class="flex justify-center w-full" :class="[{'bg-[#FF0300]' : balanceDue != '$0.00' && isOverdue}, {'bg-[#FFFF01]' : balanceDue != '$0.00' && !isOverdue}]" >
                    {{ balanceDue }}
                </div>
                <span v-if="isWaived" class="mt-0.5 text-[10px] uppercase tracking-wide bg-gray-200 text-gray-700 rounded px-1.5">Waived</span>
            </div>
        </base-table-cell>
        <base-table-cell>
            <div class="flex items-center gap-x-2">
                <div class="relative group">
                    <button @click="openForm" aria-label="Edit invoice" class="p-1 rounded border border-dark-primary text-dark-primary hover:bg-dark-primary hover:text-white">
                        <PencilSquareIcon class="h-4 w-4" />
                    </button>
                    <span class="pointer-events-none absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded bg-dark-primary text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-10">Edit invoice</span>
                </div>
                <div v-if="canAttachPdf" class="relative group">
                    <button @click="pdfFileInput?.click()" :disabled="uploadingPdf" aria-label="Upload PDF" class="p-1 rounded border border-dark-primary text-dark-primary hover:bg-dark-primary hover:text-white disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-dark-primary">
                        <ArrowUpTrayIcon class="h-4 w-4" />
                    </button>
                    <span class="pointer-events-none absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded bg-dark-primary text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-10">{{ uploadingPdf ? 'Uploading…' : 'Upload PDF' }}</span>
                    <input ref="pdfFileInput" type="file" accept="application/pdf" class="hidden" @change="onPdfChosen" />
                </div>
                <div v-if="latestPdfUrl" class="relative group">
                    <button @click="openLatestPdf" aria-label="View PDF" class="p-1 rounded border border-dark-primary text-dark-primary hover:bg-dark-primary hover:text-white">
                        <DocumentTextIcon class="h-4 w-4" />
                    </button>
                    <span class="pointer-events-none absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded bg-dark-primary text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-10">View PDF</span>
                </div>
                <div v-if="canEditAndRegeneratePdf" class="relative group">
                    <button @click="emitEditFull" aria-label="Edit and regenerate PDF" class="p-1 rounded border border-purple-600 text-purple-700 hover:bg-purple-600 hover:text-white">
                        <ArrowPathIcon class="h-4 w-4" />
                    </button>
                    <span class="pointer-events-none absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded bg-purple-700 text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-10">Edit &amp; regenerate PDF (dev)</span>
                </div>
                <base-button v-if="isUnsent" @click="markSent">Mark Sent</base-button>
                <base-button v-if="canDeleteDraft" @click="confirmDelete" class="text-red-700">Delete</base-button>
            </div>
            <base-modal :is-form-visible="isFormVisible" @close="closeForm">
                <template #header>
                    <h2 class="text-lg">
                        Edit Invoice {{ invoice.invoice_number }}
                    </h2>
                </template>
                <template #body>
                    <InvoiceForm :invoice="invoice" @refetch-invoices="fetchNewInvoices" @invoice-changed="invoiceChanged = true" @close="closeForm"/>
                </template>
            </base-modal>
        </base-table-cell>
    </base-table-row>

</template>

<script>
export default {
    name: 'invoice-row'
}
</script>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import InvoiceForm from './InvoiceForm.vue';
import AllClientInvoices from './AllClientInvoices.vue'
import SentInvoiceReminders from './SentInvoiceReminders.vue'
import { PencilSquareIcon, DocumentTextIcon, ArrowUpTrayIcon, ArrowPathIcon } from '@heroicons/vue/20/solid'
import { markInvoiceSent, listInvoicePdfs, deleteInvoice, attachInvoicePdf } from '@/services/Invoice';
import { formatDateTwoDigitYear } from '@/composables/formatDate';

const props = defineProps({
    invoice: Object,
})

const store = useStore()
const $toast = useToast()

const emit = defineEmits(['refetch-invoices', 'edit-full'])

function fetchNewInvoices() {
    emit('refetch-invoices')
}

function showSentInvoiceReminders() {
    sentInvoiceRemindersVisible.value = true
}

function hideSentInvoiceReminders() {
    sentInvoiceRemindersVisible.value = false
}

const allClientInvoicesVisible = ref(false)

function showAllClientInvoices() {
    allClientInvoicesVisible.value = true
}

function hideAllClientInvoices() {
    allClientInvoicesVisible.value = false
}

const sentInvoiceRemindersVisible = ref(false)

const isUnsent = computed(() => {
    return !props.invoice.sent_date
})

const hasReminders = computed(() => {
    return props.invoice.sent_reminders.length > 0
})

const isFormVisible = ref(false)
const invoiceChanged = ref(false)

const latestPdfUrl = computed(() => props.invoice?.latest_pdf_archive?.file_url || null)
const isWaived = computed(() => (props.invoice.payments || []).some(payment => payment.payment_type === 'Waived'))

function openForm () {
    isFormVisible.value = true
}

function closeForm() {
    console.log('closing')
    isFormVisible.value = false
    if (invoiceChanged.value) {
        invoiceChanged.value = false
        emit('refetch-invoices')
    }
}

async function markSent(){
    const token = store.state.auth.token
    const result = await markInvoiceSent(props.invoice.id, token)
    if (result.status == 200){
        $toast.open({
            message: 'Marked invoice sent',
            type: 'success',
            duration: 3000
        })
        emit('refetch-invoices')
    } else {
        $toast.open({
            message: 'Could not mark invoice sent',
            type: 'error',
            duration: 3000
        })
    }
}

const isNativeAerocle = computed(() => {
    return !props.invoice.wave_status
})

const userPermissions = computed(() => store.getters['auth/showUserPermissions'] || {})
const isDevUser = computed(() => !!userPermissions.value.isDev)
const isAccountingGroup = computed(() => !!userPermissions.value.isAccountingGroup)

function emitEditFull() {
    emit('edit-full', props.invoice)
}
const canDeleteDraft = computed(() =>
    props.invoice.status === 'Draft'
    && (!!userPermissions.value.isDev || !!userPermissions.value.isAccountingGroup)
)
const canAttachPdf = computed(() =>
    !!userPermissions.value.isDev || !!userPermissions.value.isAccountingGroup
)

const canEditAndRegeneratePdf = computed(() =>
    !!userPermissions.value.isDev || !!userPermissions.value.isAccountingGroup
)

const pdfFileInput = ref(null)
const uploadingPdf = ref(false)

async function openLatestPdf() {
    // Re-fetch on click — the presigned URL embedded at page-load time
    // expires after 1 hour and would 403 if the user lets the page sit.
    try {
        const archives = await listInvoicePdfs(props.invoice.id, store.state.auth.token)
        const fresh = archives?.[0]?.file_url
        if (fresh) {
            window.open(fresh, '_blank', 'noopener')
            return
        }
    } catch (err) {
        console.error('Failed to refresh PDF URL', err)
    }
    if (latestPdfUrl.value) {
        window.open(latestPdfUrl.value, '_blank', 'noopener')
    } else {
        $toast.open({ message: 'No PDF available.', type: 'error', duration: 3000 })
    }
}

async function onPdfChosen(event) {
    const file = event.target.files?.[0]
    if (!file) return
    uploadingPdf.value = true
    try {
        await attachInvoicePdf(props.invoice.id, file, store.state.auth.token)
        $toast.open({ message: 'PDF attached', type: 'success', duration: 3000 })
        emit('refetch-invoices')
    } catch (err) {
        const detail = err?.response?.data?.file
            || err?.response?.data?.detail
            || 'Upload failed.'
        $toast.open({ message: detail, type: 'error', duration: 5000 })
    } finally {
        uploadingPdf.value = false
        if (pdfFileInput.value) pdfFileInput.value.value = ''
    }
}

async function confirmDelete() {
    if (!window.confirm(`Delete draft invoice #${props.invoice.invoice_number || props.invoice.id}? This cannot be undone.`)) return
    try {
        await deleteInvoice(props.invoice.id, store.state.auth.token)
        $toast.open({ message: 'Draft deleted', type: 'success', duration: 3000 })
        emit('refetch-invoices')
    } catch (err) {
        const detail = err?.response?.data?.detail || 'Delete failed.'
        $toast.open({ message: detail, type: 'error', duration: 5000 })
    }
}

const isOverdue = computed(() => {
    const overdueStatuses = ['Unpaid', 'unpaid']
    const dueDate = new Date(props.invoice.due_date).getTime()
    const today = new Date().getTime()
    return (today > dueDate) && overdueStatuses.includes(props.invoice.status)
})

const invoiceAmount = computed(() => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(props.invoice.invoice_amount);

})
const amountPaid = computed(() => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(props.invoice.amount_paid);
})

const balanceDue = computed(() => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(props.invoice.invoice_amount - (props.invoice.amount_paid ? props.invoice.amount_paid : 0));
})

const paymentTiming = computed(() => {
    if(props.invoice.date_paid){
        const date1 = new Date(props.invoice.due_date);
        const date2 = new Date(props.invoice.date_paid);
        const diffTime = (date1 - date2);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays
    } else {
        const date1 = new Date(props.invoice.due_date);
        const date2 = new Date();
        const diffTime = (date1 - date2);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays
    }
})


const returnDate = (invoiceDate) => {
        let date = new Date(invoiceDate)
        date.setDate(date.getDate() + 1)
        return date.toLocaleDateString('en-US', {day: '2-digit', month: '2-digit', year: '2-digit'})
    }

</script>

<style>
.itemsTable-enter-active,
.itemsTable-leave-active {
  transition: all 0.2s ease-in;
}
.itemsTable-enter-from {
    transform: scaleY(0);
    transform-origin: top;
}
.itemsTable-leave-to {
  transform: scaleY(0);
  transform-origin: top;
}
</style>